import React from "react";
import Buttons from "../../components/Elements/Buttons";

const About = () => {
  return (
    <div className="relative">
      <img
        className="w-full h-[700px] max-lg:h-[65vh] max-lg:w-auto"
        src="/assets/homepage-about-image.png"
        alt="About Background"
      />
      <div className="absolute top-28 max-lg:top-10 lg:px-20">
        <div className="flex max-lg:flex-col justify-between gap-10 font-semibold">
          <img
          className="max-lg:px-10"
            src="/assets/home-about-video.png"
            alt="YouTube Video"
          />
          <div className="text-[#67142D] px-20 max-lg:mt-[-30px]">
            <h4 className="lg:text-4xl font-source-serif-4">
            सनातन का दीपस्तम्भ - विश्व सनातन महापीठ
            </h4>
            <p className="text-[20px] max-lg:text-[8px] font-inter lg:leading-7 font-normal lg:mt-4">
            जब युग में धर्म धुंधला पड़े,
 और मानवता अपने मार्ग से भटक जाए  तब आवश्यक होता है एक दीप,
 जो सबको सत्य, करुणा और एकता की दिशा दिखाए।
विश्व सनातन महापीठ वही दिव्य दीपस्तम्भ है, जो धर्म, ज्ञान, विज्ञान और संस्कृति को जोड़क,  नवयुग के पुनर्जागरण का केंद्र बनता है।



            </p>
            <p className="text-[20px] max-lg:text-[8px] font-inter lg:leading-7  font-normal lg:mt-4">
            यहाँ से आरंभ होता है वह आंदोलन,
 जहाँ आस्था सेवा बनती है, और सेवा साधना।
 जहाँ सनातन केवल स्मृति नहीं, एक जीवित चेतना बनकर प्रकट होता है।
            </p>
            <p className="text-[20px] max-lg:text-[8px] font-inter lg:leading-7  font-normal lg:mt-4">
            यह महापीठ मानवता, वैदिक ज्ञान और संस्कारों का जीवंत संगम है।
            </p>

            <Buttons
              color="red"
              textColor="white"
              buttonText="Download Deck"
              className="lg:mt-6"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
